import AuthUserType from '@domain/auth/types/auth.user.type';
import { GameInfo } from '@domain/game.selection/types/game.info';

function getGameKey(game: GameInfo) {
  return `@Auth:${game.urlId}:user`;
}

function getStorage(persistent: boolean | undefined) {
  return persistent ? localStorage : sessionStorage;
}

function getStorageItem(key: string) {
  return sessionStorage.getItem(key) || localStorage.getItem(key);
}

export function getUserData(game: GameInfo): AuthUserType | null {
  const loggedUserJson = getStorageItem(getGameKey(game));
  if (!loggedUserJson) return null;
  return JSON.parse(loggedUserJson) as AuthUserType;
}

export function setUserData(game: GameInfo, persistent: boolean | undefined, userData: AuthUserType): void {
  getStorage(persistent).setItem(getGameKey(game), JSON.stringify(userData));
}

export function clearUserData(game: GameInfo): void {
  const key = getGameKey(game);
  sessionStorage.removeItem(key);
  localStorage.removeItem(key);
}
